module.exports = __webpack_public_path__ + "img/logo.61c57368.png";